const nn = {
  ACCESS_DENIED: 'Ingen tilgang',
  ACCESS_DENIED_HEADING: 'Du har ikke tilgang til denne digitale boken enda',
  ACCESS_DENIED_BUTTON_TEXT: 'Prov gratis i 30 dager',
  ACCESS_DENIED_CONTACT_TEXT: 'Spørsmal? Ta kontakt på <a href="mailto:digitalt@fagbokforlaget.no">digitalt@fagbokforlaget.no</a>',
  ALL: 'Alle',
  LOCALE: 'nn_NO',
  UI_LANG: 'Norsk nynorsk',
  DICT_LANG: 'nynorsk',
  LOGIN_BUTTON: 'Logg inn eller registrer deg',
  LOGIN_WELCOME: 'Innlogging for d-bok',
  LOGOUT: 'Logg ut',
  BOOK_COVER: 'Bokomslag',
  YOU_ARE_OFFLINE: 'Ingen Internett-tilgang',
  LANGUAGE: 'Språk',
  CHANGE_LANGUAGE: 'Vel språk',
  CHOOSE_LANGUAGE: 'Byt språk',
  WHILE_ONLINE_TITLE: 'Les bøker med eller utan nettilkopling.',
  WHILE_ONLINE: 'Du kan lese alle dine bøker når du er kopla til Internett. Om du vil lese bøker utan å vere kopla til nett, må du laste dei ned først. Alle uthevingar og notat som du gjer når du er fråkopla, blir synkroniserte når du koplar til Internett igjen.',
  OKAY: 'Greitt!',
  GOT_IT: 'OK!',
  MY_LIBRARY: 'Mitt bibliotek',
  SORT_BY: 'Sorter etter',
  DOWNLOADED_BOOKS: 'Nedlasta bøker',
  DOWNLOADED: 'Nedlastet',
  DOWNLOADING: 'Nedlasting',
  RECENTLY_OPENED: 'Nyleg opna',
  ORDER_ASC: 'Tittel A–Å',
  ORDER_DESC: 'Tittel Å–A',
  BOOK_DOWNLOAD: 'Last ned',
  BOOK_DOWNLOADING: 'Nedlasting',
  BOOK_READ: 'Les',
  SINCE_YOU_ARE_OFFLINE: 'Sidan du er fråkopla, vil nokre deler av applikasjonen vere utilgjengelege fram til du er tilkopla igjen.',
  TERMS_AND_CONDITIONS: 'Vilkår og føresetnader',
  HELP: 'Hjelp',
  BACK_TO_LIBRARY: 'Tilbake til biblioteket',
  BACK_TO_THE_BOOK: 'Tilbake til boka',
  MY_NOTEBOOK: 'Mi notatbok',
  TABLE_OF_CONTENTS: 'Innhaldsliste',
  FAVORITES: 'Favorittar',
  HIGHLIGHTS: 'Uthevingar',
  HIGHLIGHTS_NO_CONTENT: 'Du har ikkje lagt til nokre uthevingar i denne boka.',
  NOTES: 'Notat',
  NEWEST: 'Nyaste først',
  WORDBANK: 'Ordbank',
  SEARCH_IN_BOOK: 'Søk i bok',
  SEARCH_PLACEHOLDER: 'Kva leitar du etter?',
  SEARCH_RESULT_COUNT: 'resultat for søk',
  SEARCH_NO_RESULTS: 'Ingen resultat funne',
  SEARCH_EMPTY_TEXT: 'Søkefeltet ditt er tomt.',
  SEARCH_OFFLINE_HEADING: 'Du er fråkopla',
  SEARCH_OFFLINE: 'Denne funksjonen er ikkje tilgjengeleg når du er fråkopla. Kople til Internett og prøv igjen.',
  SEARCH_LOADING: 'Søkjer...',
  SEARCH_NO_RESULTS_TEXT: 'Søk etter {phrase} gav ingen treff i denne boka. Prøv igjen med eit anna søkeord.',
  SETTINGS: 'Innstillingar',
  SIZE_ASC: 'Storleik stigande',
  SIZE_DESC: 'Storleik synkande',
  SLIDER_PREVIOUS: 'Forrige',
  SLIDER_NEXT: 'Neste',
  PRINT: 'Skriv ut',
  DOWNLOAD: 'Last ned',
  TOC_NO_CONTENT: 'Denne boka har inga innhaldsliste.',
  SHOW_NAVIGATION: 'Vis navigasjon',
  HIDE_NAVIGATION: 'Skjul navigasjon',
  FAVORITES_NO_CONTENT: 'Ingen favorittar',
  FAVORITES_NOT_ADDED: 'Du har ikkje lagt til nokre favorittsider i denne boka.',
  ACTUAL_SIZE: 'Faktisk storleik',
  FIT_TO_SCREEN: 'Tilpass skjermen',
  ZOOM_IN: 'Zoom inn',
  ZOOM_OUT: 'Zoom ut',
  ZOOM_CHANGE: 'Endre zoom',
  ZOOM_FIT_TO_SCREEN: 'Tilpass høgda',
  ANNOTATOR_HIGHLIGHT: 'Utheving',
  ANNOTATOR_ADD_NOTE: 'Notat',
  ANNOTATOR_WORDBANK: 'Ordbank',
  ANNOTATOR_LOOK_UP: 'Slå opp',
  LOOKUP_TITLE: 'Ordbok',
  LOOKUP_NO_CONTENT: 'Vi kunne dessverre ikkje finne nokon omsetjing for denne teksten.',
  NOTES_NO_CONTENT: 'Ingen notat',
  NOTES_NOT_ADDED: 'Du har ikkje lagt til nokre notat i denne boka.',
  DBOK_READER: 'd-bok Reader',
  DBOK_FILE: 'd-bok-data',
  LIBRARY: 'Bibliotek',
  SELECT_TO_ARCHIVE: 'Vel for å fjerne frå eining',
  ARCHIVE: 'Fjern frå eining',
  CANCEL: 'Avbryt',
  SAVE: 'Lagre',
  PROCESSING: 'Behandlar...',
  DELETING: 'Slettar...',
  DELETE: 'Slette',
  PAGES_PER_VIEW: 'Sider per vising',
  EDIT_NOTE: 'Rediger notat',
  NEW_NOTE: 'Nytt notat',
  ONE_PAGE: 'Enkeltside',
  TWO_PAGES: 'Dobbeltside',
  PAGE: 'Side',
  GO_TO: 'Gå til',
  PAGES_OUT_OF_TOTAL: 'av {0}',
  AT: 'kl.',
  NEXT_PAGE: 'Neste side',
  PREVIOUS_PAGE: 'Førre side',
  ADD_TO_FAVORITES: 'Legg til denne sida som favoritt',
  REMOVE_FROM_FAVORITES: 'Fjern denne sida som favoritt',
  HIDE_THUMBNAILS: 'Skjul miniatyrbilete',
  EXPAND_THUMBNAILS: 'Vis miniatyrbilete',
  PAGE_NUMBER: 'Sidetal',
  CLOSE_MESSAGE: 'Lukk denne meldinga',
  NEXT_THUMBNAILS_ROW: 'Neste gruppe av miniatyrbilete',
  CLOSE_MENU: 'Lukk meny',
  CLEAR_INPUT: 'Reins søkjefelt',
  FOCUS_INPUT: 'Fokus på søkjefelt',
  NOTE: 'Notat',
  HIGHLIGHT: 'Utheving',
  TOGGLE_SUBCHAPTERS: 'Vis/skjul underkapittel',
  SEARCH_RESULT: 'Søkjeresultat',
  IS_AVAILABLE_ONLINE: 'er tilgjengeleg med nettilkopling',
  IS_AVAILABLE_OFFLINE: 'er tilgjengeleg utan nettilkopling',
  SWITCH_TO_OLD_DBOK: 'Skift til gammal d-bok',
  BASE_FORM: 'Grunnform',
  WORD_CLASS: 'Ordklasse',
  FORM: 'Form',
  FROM: 'Frå',
  TO: 'Til',
  INFLECTION: 'Bøying',
  VIEW_DETAILS: 'Vis detaljar',
  HIDE_DETAILS: 'Skjul detaljar',
  LISTEN_TO_PHRASE: 'Lytt til uttale',
  SYNONYMS: 'Synonymer',
  LOGIN_WELCOME_HEADING: 'Velkommen til Nye d-bok!',
  LOGIN_WELCOME_PARAGRAPH: 'Nye d-bok er eit heilt nyutvikla program for å lese Fagbokforlagets d-bøker.',
  LOGIN_WELCOME_LIST1: 'lese d-bøker i nettlesaren også når du ikkje har tilgang til nett',
  LOGIN_WELCOME_LIST2: 'ny teknologi og nytt design',
  LOGIN_WELCOME_INFO1: 'Sidan dette er ein betaversjon, er det noko funksjonalitet som ikkje er klar enno.',
  LOGIN_WELCOME_INFO2: 'Les meir på <a target="_blank" href="https://www.fagbokforlaget.no/d-bok">https://www.fagbokforlaget.no/d-bok</a>.',
  ALTERNATIVE_SPELLINGS: 'Alternativ skrivemåte',
  LOOKUP_LOADING: 'Slår opp...',
  FEEDBACK_TITLE: 'Gi oss ei tilbakemelding',
  FEEDBACK_TEXT: 'Vi ønskjer å høyre frå deg! Korleis kan vi forbetre våre d-bøker?',
  FEEDBACK_YOUR_EMAIL: 'E-post:',
  FEEDBACK_SUBMIT: 'Send',
  FEEDBACK_CLOSE: 'Lukk',
  FEEDBACK_THANK_YOU: 'Takk for tilbakemeldinga!',
  FEEDBACK_FAILED:  'Noko gikk gale ved innsending av skjemaet.',
  FEEDBACK_TEXT_REQUIRED: 'Skriv tilbakemeldinga her.',
  FEEDBACK_EMAIL_REQUIRED: 'E-post er obligatorisk.',
  FEEDBACK_EMAIL_INVALID: 'E-postadressa er ikkje gyldig.'
}

export default nn
